import MedicalRecordList from './MedicalRecordList';

export const AllergiesPage = () => <MedicalRecordList type='ALLERGY' i18nKey='allergies' permissionAction='manageAllergy' />;

export const HealthHistoryPage = () => (
  <MedicalRecordList type='HEALTH_HISTORY' i18nKey='healthHistory' permissionAction='manageHealthHistory' />
);

export const TestResultsPage = () => (
  <MedicalRecordList type='TEST_RESULT' i18nKey='testResults' permissionAction='manageTestResult' />
);
